import script from "./DashboardSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardSection.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardSection.vue?vue&type=style&index=0&id=b1a4419c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1a4419c"]])

export default __exports__